import React, { useState, useEffect } from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import Modal from '../../.././components/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faFolderPlus } from '@fortawesome/free-solid-svg-icons';
import { faFileMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import CustomToast from '../../../components/Toast';
import appConfig from '../../../app-config';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from '../../../features/authentication/authSlice';
import HesSpinner from '../../../components/loadingOverlay/hesSpinner';
import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { selectCurrentUserData } from '../../../features/authentication/authSlice';
import { useAssignmentContext } from '../context';
import { useData } from '../DataContext';
import DropDown from '../../../components/DropDown';
import { useCreateAssignmentMutation } from '../../../features/authentication/assignmentApislice';
import '../../../styles/globalStyle.scss';
import PropTypes from 'prop-types';
import FolderDropdown from '../../../components/FolderDropdown';

const baseUrl = appConfig.apiBaseUrl;
const AssignmentCreateContent = ({ showBrowseContent, showTitle, showCancelButton, handleCancel, onCreateSuccess }) => {
  const [createAssignment] = useCreateAssignmentMutation();
  const [isImportXML, setIsImportXML] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);
  const [files, setFiles] = useState(null);
  const [fileString, setFileString] = useState('');
  const [loadingProgress, setLoadingProgress] = useState('0%');
  const [isUploaded, setIsUploaded] = useState(false);
  const token = useSelector(selectCurrentToken);
  const navigate = useNavigate();
  const user = useSelector(selectCurrentUserData);
  const selectedAssignment = useAssignmentContext();
  const [dateBasedKey, setDateBasedKey] = React.useState(new Date().getTime().toString());
  const { courseData, folderData, assignedViaData } = useData();
  const [selectedCourseId, setSelectedCourseId] = useState('');
  const [allCourses, setAllCourses] = useState([]);
  const [selectedFolderId, setSelectedFolderId] = useState(0);
  const [allFolders, setAllFolders] = useState([]);
  const [selectedAssignedViaId, setAssignedViaId] = useState(1);
  const [enteredName, setEnteredName] = useState('');
  const [validName, setValidName] = useState(true);
  const [validCourseSelected, setValidCourseSelected] = useState(true);
  const [validAssignedViaSelected, setValidAssignedViaSelected] = useState(true);
  const [allParents, setAllParents] = useState([]);
  const sharedFolder = '*** Shared Assignments ***';

  const handleImportXML = () => {
    setIsImportXML(true);
  };

  const handleCreatePublicAssignment = () => {
    navigate('/assignments/create_public_assignment');
  };

  const handleFileUpload = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    setFiles(file);
    setIsUploaded(true);
  };

  const handleUploadXMLfile = async () => {
    setIsWaiting(true);
    const fileName = files.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();
    if (fileExtension === 'xml') {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const content = e.target.result;
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(content, 'text/xml');
        const xmlString = new XMLSerializer().serializeToString(xmlDoc);

        const chunkSize = 10 * 1024 * 1024; // 10MB chunks
        const totalChunks = Math.ceil(xmlString.length / chunkSize);

        for (let i = 0; i < totalChunks; i++) {
          const start = i * chunkSize;
          const end = (i + 1) * chunkSize;
          const chunk = btoa(xmlString.substring(start, end));
          if (i == 0 && totalChunks == 1) setLoadingProgress('100%');
          else setLoadingProgress(Math.round((i / totalChunks) * 100) + '%');
          if (!(await uploadChunk(chunk, i + 1, totalChunks, fileName))) break;
        }
      };
      reader.readAsText(files);
    } else {
      CustomToast('Invalid file type. Please select an XML file.', 'warning');
    }
  };

  const uploadChunk = async (chunk, currentChunk, totalChunks, fileName) => {
    let url = baseUrl + '/Assignment/ImportXML';
    let options = {
      fileName: fileName,
      fileContent: chunk,
      currentChunk: currentChunk,
      totalChunks: totalChunks
    };

    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
    const response = await fetch(url, {
      headers,
      method: 'POST',
      body: JSON.stringify(options)
    });

    if (currentChunk == totalChunks) {
      if (response.status === 200) {
        setFiles(null);
        setIsImportXML(false);
        CustomToast('File Uploaded Successfully.', 'success');
        selectedAssignment.setAssignedDataStatus(new Date().getSeconds());
      } else {
        CustomToast('File Uploaded Failed.', 'error');
      }
    } else {
      if (response.status === 200) {
        return true;
      } else {
        setFiles(null);
        CustomToast('File Uploaded Failed.', 'error');
        setIsWaiting(false);
        setLoadingProgress('0%');
        return false;
      }
    }
    setIsWaiting(false);
    setLoadingProgress('0%');
  };

  let request = (obj) => {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open(obj.method || 'POST', obj.url);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Authorization', 'Bearer ' + token);
      xhr.set;
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr);
        } else {
          reject(xhr);
        }
      };
      xhr.onerror = () => reject(xhr.statusText);
      xhr.send(obj.body);
    });
  };

  const handleSelectCourse = (event) => {
    setSelectedCourseId(parseInt(event.target.value));
    setValidCourseSelected(parseInt(event.target.value) > 0);
  };

  const handleAssignedViaChange = (event) => {
    setAssignedViaId(parseInt(event.target.value));
    setValidAssignedViaSelected(parseInt(event.target.value) > 0);
  };

  const getAllCoursesAsync = async () => {
    try {
      const obj = {
        id: 0,
        name: 'Select Course'
      };
      const courseArray = [obj, ...courseData];
      courseArray !== null && courseArray !== undefined
        ? setAllCourses(courseArray)
        : setAllCourses([obj]);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllFoldersAsync = async () => {
    try {
      const folderArray = [];
      const parentfolderArray = [];

      folderData.filter(item => item.folderID !== -88 && !item.description.toLowerCase().includes(sharedFolder.toLowerCase())).map((item) => {
        const obj = {
          id: item.folderID,
          name: item.description
        };
        folderArray.push(obj);
        if (item.parent === 0)
          parentfolderArray.push(obj);
      });
      const objData = {
        id: -1,
        name: 'No Parent'
      };
      const parentArrayResponse = [objData, ...parentfolderArray];
      setAllParents(parentArrayResponse);
      setAllFolders(folderArray);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCreate = async () => {
    setValidName(enteredName.length > 0);
    setValidCourseSelected(selectedCourseId > 0);
    setValidAssignedViaSelected(selectedAssignedViaId > 0);

    if (!selectedCourseId > 0 || !selectedAssignedViaId > 0 || !enteredName.length > 0) {
      return;
    }

    var options = {
      CourseId: selectedCourseId,
      Description: enteredName,
      FolderId: selectedFolderId,
      AssignedViaId: selectedAssignedViaId,
      Activity: 5
    };
    try {
      const response = await createAssignment(options);
      if (response.error) {
        if (response.error.data.errors)
          CustomToast(response.error.data.errors.Description, 'error');
        else
          CustomToast(response.error.data.error, 'error');
      } else if (response.data) {
        CustomToast('Assignment Created Successfully', 'success');
        setSelectedCourseId(null);
        setAssignedViaId(1);
        setSelectedFolderId(0);
        setEnteredName('');
        if (onCreateSuccess) {
          onCreateSuccess(response.data.assignmentId, {id: selectedAssignedViaId, name: assignedViaData.find(a => a.id == selectedAssignedViaId).name});
        } else {
          navigate('/questionsSearch/assignment/' + response.data.assignmentId + '/castle_questions/questions', {
            replace: true, state: {
              assignedViaDetails: {
                id: selectedAssignedViaId,
                name: assignedViaData.find(a => a.id == selectedAssignedViaId).name
              }
            }
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    try {
      if (fileString.length > 0) {
        request({
          url: `${baseUrl}/Assignment/ImportXML`,
          body: JSON.stringify(fileString)
        }).then((data) => {
          var statusText = data.responseText;
          let jsonObject = JSON.parse(statusText);
          let errorMessage = jsonObject.error;
          console.log('errorMessage: ' + errorMessage);
          if (data.status === 200) {
            if (statusText === 'true') {
              CustomToast('File Uploaded Successfully', 'success');
              setFiles(null);
              setIsImportXML(false);
              setIsWaiting(false);
            } else {
              CustomToast('Error! Failed to Upload XML file', 'error');
              setIsWaiting(false);
            }
          }
        });
        setFileString('');
      }
    } catch (ex) {
      CustomToast(ex.response, 'error');
      console.log(ex);
    }
  }, [fileString]);

  useEffect(() => {
    getAllCoursesAsync();
  }, [courseData]);

  useEffect(() => {
    getAllFoldersAsync();
  }, [folderData]);


  return (
    <>
      {showTitle && <div className="row align-items-center mb-4">
        <div className="col-lg-5">
          <h4 className="secondary-title mb-lg-0">Create New Assignment</h4>
        </div>
      </div>
      }
      <Row>
        <Col className={`${showBrowseContent ? 'col-xl-8' : ''}`}>
          <Row>
            <Col className="col-md-6 mb-3">
              <DropDown
                key={dateBasedKey}
                label="Select Course"
                value={allCourses}
                onChangeHandler={(e) => handleSelectCourse(e)}
                selectedValue={selectedCourseId}
                showValidation={!validCourseSelected}
                dropDownName={'Course'}
              />
            </Col>
            <Col className="col-md-6 mb-3">
              <Form.Group>
                <Form.Label htmlFor="classDropdown">Select Folder</Form.Label>
                <FolderDropdown
                  allFolders={allFolders}
                  allParents ={allParents}
                  dropdownId="folderList"
                  selectedId={selectedFolderId}
                  setSelectedFolderId={setSelectedFolderId}
                />
              </Form.Group>
            </Col>
            <Col className="col-md-6 mb-3">
              <label className="form-label">Assignment Name</label>
              <input
                type="text"
                className={`form-control ${!validName ? 'border-danger' : ''}`}
                value={enteredName}
                onChange={(e) => setEnteredName(e.target.value)}
              />
              {!validName && <p className='text-danger'>Assignment Name Is Required.</p>}
            </Col>
            <Col className="col-md-6 mb-3">
              <DropDown
                key={dateBasedKey}
                label="Select Assigned Via"
                value={assignedViaData}
                onChangeHandler={(e) => handleAssignedViaChange(e)}
                selectedValue={selectedAssignedViaId}
                showValidation={!validAssignedViaSelected}
                dropDownName={'Assigned Via'}
              />
            </Col>
            <Col className="col-12 d-flex flex-column flex-sm-row gap-3 align-items-center">
              {showTitle &&
                <div className="d-flex flex-wrap gap-3">
                  <button
                    className="btn-link secondary-link px-0 text-start"
                    onClick={handleCreatePublicAssignment}>
                    <i className="fa-solid fa-layer-group me-2"></i>Create From Public Assignments
                  </button>
                  {user.UserType == 3 && (
                    <button
                      className="btn-link secondary-link px-0 text-start"
                      onClick={() => handleImportXML()}>
                      <i className="fa-solid fa-file-import me-2"></i>Import Assignment
                    </button>
                  )}
                </div>
              }
              <div className="ms-auto d-flex flex-column flex-sm-row create-btn-group create-btn-group">
                {showCancelButton &&
                  <div className='p-2'>
                    <button className="btn btn-castleGray option-btn btn-width" onClick={handleCancel}>
                      Cancel
                    </button>
                  </div>
                }
                <div className='p-2'>
                  <button className="btn outline-btn btn-width" onClick={handleCreate}>
                    Create
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        {showBrowseContent && <Col className="col-xl-4 mt-4 mt-xl-0">
          <NavLink
            to={'/questionsSearch'}
            className="select-questions h-100 p-4 d-flex flex-column align-items-center justify-content-center text-center text-decoration-none">
            <span className="mb-3 d-flex align-items-center justify-content-center nav-link-browse-content">
              <FontAwesomeIcon color="#82A9E2" icon={faFileMagnifyingGlass} />
            </span>
            <h4>Browse Content</h4>
            <p className="mb-0">Select the questions first, then create a new assignment.</p>
          </NavLink>
        </Col>
        }
      </Row>

      {isImportXML && (
        <Modal
          contentWidth="700px"
          isOpen={isImportXML}
          titleName={'Upload Assignment'}
          onClose={() => {
            setIsImportXML(false);
            setFiles(null);
            setIsWaiting(false);
          }}>
          {!isWaiting ? (
            <>
              <p>Select an XML Assignment file.</p>
              <div className="upload_xml">
                <div className="row mb-3">
                  <div className="col-12">
                    <div
                      className="custom-upload position-relative d-flex flex-column justify-content-center align-items-center p-5 text-center"
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        e.dataTransfer.dropEffect = 'copy';
                      }}
                      onDragEnter={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const file = e.dataTransfer.files[0];
                        console.log('File dropped:', file);
                        setFiles(file);
                        setFileString(e.target.result);
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const file = e.dataTransfer.files[0];
                        console.log('File dropped:', file);
                        setFiles(file);
                        setFileString(e.target.result);
                        // Do something with the file here
                      }}>
                      <input
                        onChange={handleFileUpload}
                        className="form-control position-absolute w-100 h-100 top-0 start-0"
                        type="file"
                        accept=".xml"
                      />
                      <span className="d-block mb-2">
                        {' '}
                        <FontAwesomeIcon icon={faUpload} />
                      </span>
                      <p className="mb-0">
                        <strong>Click to upload</strong> or Drag and drop file
                      </p>
                      {files && (
                        <div className="mt-3">
                          <p>{files.name}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="d-flex justify-content-center align-items-center h-40">
              <HesSpinner />
              <span className="ms-3">{loadingProgress} Uploaded... </span>
            </div>
          )}
          <div className="d-flex justify-content-end gap-3 pt-2">
            <button
              className="btn btn-castleGray print-btn"
              onClick={() => {
                setIsImportXML(false);
                setFiles(null);
                setIsWaiting(false);
              }}>
              Cancel
            </button>
            <button
              className={'btn btn-castleRed print-btn'}
              onClick={handleUploadXMLfile}
              disabled={isWaiting}>
              Import
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

AssignmentCreateContent.propTypes = {
  showBrowseContent: PropTypes.bool,
  showTitle: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  handleCancel: PropTypes.func,
  onCreateSuccess: PropTypes.func
};

export default AssignmentCreateContent;
